import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Shield, Lock, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("admin_token", res.data.token);
      toast.success("Velkommen til Admin Panel");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Forkert login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-red-500/20 to-red-500/5 flex items-center justify-center mx-auto mb-4">
            <Shield className="h-8 w-8 text-red-400" />
          </div>
          <h1 style={{ fontFamily: 'Oswald, sans-serif' }} className="font-bold text-3xl uppercase tracking-tight text-white">
            Admin Panel
          </h1>
          <p className="text-sm text-zinc-500 mt-2">FitrackR Administration</p>
        </div>

        <div className="bg-[#18181b] border border-white/5 rounded-2xl p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-xs uppercase tracking-wider text-zinc-500 mb-1.5 block">Admin Email</Label>
              <Input 
                type="email" 
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                required
                className="bg-zinc-900/50 border-zinc-800 focus:border-red-400 rounded-lg h-12"
                data-testid="admin-email"
                placeholder="admin@fitplandk.dk"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-zinc-500 mb-1.5 block">Adgangskode</Label>
              <Input 
                type="password" 
                value={password} 
                onChange={e => setPassword(e.target.value)} 
                required
                className="bg-zinc-900/50 border-zinc-800 focus:border-red-400 rounded-lg h-12"
                data-testid="admin-password"
                placeholder="••••••••"
              />
            </div>
            <Button 
              type="submit" 
              disabled={loading}
              className="w-full bg-red-500 hover:bg-red-600 text-white rounded-lg font-bold uppercase tracking-wider h-12"
              data-testid="admin-submit"
            >
              {loading ? "Logger ind..." : <><LogIn className="mr-2 h-4 w-4" /> Log ind</>}
            </Button>
          </form>
        </div>

        <p className="text-center text-xs text-zinc-600 mt-6">
          Kun autoriseret personale
        </p>
      </div>
    </div>
  );
}
